export default __webpack_public_path__ + "static/media/arrow-collapse.6c19ff60.svg";